import React, {useState} from "react";
import "../../css/pages/services.css";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import imageOne from "../../assets/images/Investments2.jpg";
import imageTwo from "../../assets/images/Investments3.jpg";
import imageThree from "../../assets/images/Investments3.jpg";
import imageFour from "../../assets/images/Investments4.jpg";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/Investments1.jpg";
import ContactUsPage from "./ContactUsPage";

const investmentsData = [
  {
    title: "Investments",
    subtitle: "Growing Your Wealth",
    description:
      "Building long term wealth requires a clear strategy tailored to your goals, time horizon and attitude to risk. We help you create a diversified investment portfolio designed to grow your capital while managing risk, ensuring your money works efficiently for your future.",
    image: imageOne,
  },
  {
    title: "Investments",
    subtitle: "Investments",
    description:
      "Investing is about more than returns. It is about aligning your money with your life goals. Whether you are looking for income, capital growth, or a balance of both, we provide expert guidance to help you make informed decisions and stay on track over the long term.",
    image: imageTwo,
  },
  {
    title: "Investments",
    subtitle: "Inheritance Tax",
    description:
      "Careful investment planning can play an important role in reducing potential inheritance tax liabilities. We work with you to structure your investments in a tax efficient way, helping you preserve more of your wealth for future generations while maintaining access to your funds where needed.",
    image: imageThree,
  },
  {
    title: "Investments",
    subtitle: "Estate Planning",
    description:
      "Effective estate planning ensures your wealth is passed on according to your wishes. By combining investment strategies with estate planning solutions, we help you protect your assets, provide for your loved ones, and create a lasting financial legacy.",
    image: imageFour,
  },
];

const InvestmentsPage = () => {
  // State to track which descriptions are shown
  const [showDescriptions, setShowDescriptions] = useState(
    investmentsData.map(() => true),
  );

  // Handler to toggle description visibility for a card
  const handleSeeMoreClick = (idx) => {
    setShowDescriptions((prev) =>
      prev.map((shown, i) => (i === idx ? !shown : shown)),
    );
  };

  return (
    <div className="home-page about-page">
      <Hero
        title="Straightforward investment advice you can trust"
        subtitle="Investments"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="page-section">
        <div className="page-section-inner">
          <div className="page-card-grid">
            {investmentsData.map((investment, index) => (
              <div className="page-card" key={index}>
                <div className="page-card-image">
                  <img src={investment.image} alt={investment.title} />
                </div>

                <div className="page-card-content">
                  <div className="nav primary">{investment.title}</div>
                  <h2 className="primary">
                    {investment.subtitle.split(" ")[0]}{" "}
                    <span className="italic-text">
                      {investment.subtitle.split(" ")[1]}{" "}
                      {investment.subtitle.split(" ")[2]}
                    </span>
                  </h2>
                  {showDescriptions[index] && (
                    <div className="content primary">
                      {investment.description}
                    </div>
                  )}

                  <SeeMoreButton onClick={() => handleSeeMoreClick(index)}>
                    {showDescriptions[index] ? "See Less" : "See More"}
                  </SeeMoreButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          <strong>Please Note:</strong> The value of investments and the income
          from them can fall as well as rise and you may not get back the amount
          originally invested. Past performance is not a reliable indicator of
          future performance.
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default InvestmentsPage;
